import { FC, memo } from 'react';

import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { ButtonsSet } from 'modules/RegisterModule/components/ButtonsSet';
import { useBreakpoints } from 'hooks/useBreakpoints';

import { getTruncatedText } from '../../helpers';
export interface Step2Props {
  onSubmit: () => void;
  employeeName: string;
  prevStep: () => void;
}

export const Step2: FC<Step2Props> = memo(
  ({ onSubmit, employeeName, prevStep }) => {
    const { isUpTablet } = useBreakpoints();

    return (
      <Box className="flex flex-1 flex-col items-center justify-center">
        <Typography
          variant="pSemiBold"
          className="mt-8 max-w-[44rem] break-words text-center text-[28px] md:text-[32px]"
        >
          Hi! My name is {getTruncatedText(isUpTablet, employeeName)} AI
        </Typography>

        <ButtonsSet onBack={prevStep} onNext={onSubmit} />
      </Box>
    );
  }
);
